import {
	FIELD_EDITOR_FIELDS,
	FORM_EDITOR_FIELDS,
	OPTION_EDITOR_FIELDS,
	SECTION_EDITOR_FIELDS,
} from '../hooks/useFormEditorData/constants';

/**
 * Check to see if a translation exists for the form content in a particular language.
 *
 * @param {Object} formData  The form data.
 * @param {String} language  The language.
 *
 * @returns {Boolean} result  True, if translation(s) exist.
 */
export const hasTranslationContent = (formData, language) => {

	let result = false;

	// Loop through each section in the form
	formData[FORM_EDITOR_FIELDS.SECTIONS].forEach((section) => {

		const hasSectionTranslation = Boolean(
			section[SECTION_EDITOR_FIELDS.CONTENTS].find(
				(content) => content.language === language
			)
		);

		if (hasSectionTranslation) {
			result = true;
		}

		// Loop through each field in the section
		section[SECTION_EDITOR_FIELDS.FIELDS].forEach((field) => {

			const hasFieldTranslation = Boolean(
				field[FIELD_EDITOR_FIELDS.CONTENTS].find(
					(content) => content.language === language
				)
			);

			if (hasFieldTranslation) {
				result = true;
			}

			// Loop through each option in the field
			field[FIELD_EDITOR_FIELDS.OPTIONS].forEach((option) => {

				const hasOptionTranslation = Boolean(
					option[OPTION_EDITOR_FIELDS.CONTENTS].find(
						(content) => content.language === language
					)
				);

				if (hasOptionTranslation) {
					result = true;
				}

			});

		});

	});

	return result;

};

/**
 * Check to see if a translation is set to be deleted for the form content in a particular language.
 *
 * @param {Object} formData  The form data.
 * @param {String} language  The language.
 *
 * @returns {Boolean} result  True, if translation(s) are set to be deleted.
 */
export const hasTranslationDeleted = (formData, language) => {

	let result = false;

	// Loop through each section in the form
	formData[FORM_EDITOR_FIELDS.SECTIONS].forEach((section) => {

		const hasSectionDeletion = Boolean(
			section[SECTION_EDITOR_FIELDS.DELETED_CONTENTS].find(
				(content) => content.language === language
			)
		);

		if (hasSectionDeletion) {
			result = true;
		}

		// Loop through each field in the section
		section[SECTION_EDITOR_FIELDS.FIELDS].forEach((field) => {

			const hasFieldDeletion = Boolean(
				field[FIELD_EDITOR_FIELDS.DELETED_CONTENTS].find(
					(content) => content.language === language
				)
			);

			if (hasFieldDeletion) {
				result = true;
			}

			// Loop through each option in the field
			field[FIELD_EDITOR_FIELDS.OPTIONS].forEach((option) => {

				const hasOptionDeletion = Boolean(
					option[OPTION_EDITOR_FIELDS.DELETED_CONTENTS].find(
						(content) => content.language === language
					)
				);

				if (hasOptionDeletion) {
					result = true;
				}

			});

		});

	});

	return result;

};
